import isNil from 'lodash/isNil';

import IPCamera, {
  IPCameraEvent,
  IPCameraEventPayload
} from 'types/models/ip-camera';

export function getIPCameraEventSource(
  ipCamera: Pick<IPCamera, 'barnOwlIntegrationId'> | undefined
): IPCameraEvent['source'] {
  return isNil(ipCamera?.barnOwlIntegrationId) ? 'landwatch' : 'barnOwl';
}

export function withIPCameraEventSource(
  event: IPCameraEventPayload,
  source: IPCameraEvent['source']
): IPCameraEvent {
  if (source === 'landwatch') {
    return {
      ...event,
      source,
      duration: event.duration ?? 0
    };
  }

  return {
    ...event,
    source
  };
}
